import { createContext, useContext } from 'react'
import type { FeatureAccess } from '../services/feature-authorization-service'

export type FeatureAccessState = {
  access: FeatureAccess | null
  loading: boolean
  error: boolean
  can: (permission: string, applicationId?: string) => boolean
  refresh: () => Promise<void>
}

export const FeatureAccessContext = createContext<FeatureAccessState | null>(
  null,
)

export function useFeatureAccess() {
  const context = useContext(FeatureAccessContext)
  if (!context) {
    throw new Error('useFeatureAccess must be used inside FeatureAccessProvider')
  }
  return context
}
